module.exports = __webpack_public_path__ + "fonts/monument.73b9994b.otf";